module.exports = __webpack_public_path__ + "static/media/title.78d18bb1.png";